module.exports = __webpack_public_path__ + "media/application/images/svgs/twitter-156eac91af1935b954d559eb262372a6.svg";